import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { CALCULATORS } from "./calculators";

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <span className="brand-icon">🧮</span> Hisaab Tools
        </Link>

        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>

        <nav className={`nav-links ${open ? "open" : ""}`}>
          {CALCULATORS.map((calc) => (
            <NavLink
              key={calc.path}
              to={calc.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              {calc.short}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
